import './ItemSortDirection';
import {initWizard} from '../Wizard/Wizard';

const initializedWizards = new WeakSet();

export const initializeExportWizards = root => {
    const wizards = root.matches?.('[data-controller="export-wizard"]')
        ? [root]
        : root.querySelectorAll('[data-controller="export-wizard"]');

    wizards.forEach(wizard => {
        if (initializedWizards.has(wizard)) {
            return;
        }

        initializedWizards.add(wizard);

        const navigation = initWizard(wizard, {
            validate(panel) {
                if (panel.dataset.wizardStep !== 'columns') {
                    return true;
                }

                wizard.querySelector('[data-wizard-action="continue"]')
                    .dispatchEvent(new CustomEvent('exportcolumnscheck'));

                return false;
            },
        });

        wizard.addEventListener('exportcolumnsaccepted', () => navigation.goToStep(navigation.getCurrentStep() + 1));
    });
};
